<template>
    <div :style="bgImageStyle">
        <div class="try-outfit">
            <h1 class="title">{{ title }}</h1>
            <div class="subtext">{{ subtext }}</div>
        </div>
    </div>
</template>

<script>
    import Mixins from "../../../mixins/mixins";

    export default {
        mixins: [Mixins],
        props: ['title', 'subtext'],
        computed: {
            bgImageStyle() {
                return {
                    backgroundImage: 'url(\'' + this.imageUrl('training-sample.jpg') + '\')',
                    backgroundSize: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: '86px'
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
.try-outfit {
    bottom: 80px;
    color: #fff;
    left: 0;
    position: absolute;
    right: 0;
    text-align: center;
}
.title {
    font-size: 32px;
    line-height: 40px;
    font-weight: 600;
    max-width: 260px;
    margin: 0 auto 14px;
}
.subtext {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.6px;
    max-width: 290px;
    margin: 0 auto;
}
</style>
